<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onCreateEvent"
  >
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa händelse
      </v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col class="mt-7">
            <EventTitleField />
            <EventTimeStartField />
            <EventLocationField />
            <EventRoutesField />
          </v-col>
          <v-col>
            <v-card flat outlined class="grey lighten-4" height="216">
              <v-card-text>
                <v-row>
                  <EventReasonField />
                  <EventOperationLevelField />
                </v-row>
                <EventBasunFields />
              </v-card-text>
            </v-card>
            <v-row>
              <v-col>
                <v-textarea
                  no-resize
                  outlined
                  label="Kommentar"
                  v-model="model.comment"
                  placeholder=" "
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn
          rounded
          type="submit"
          color="primary"
          :loading="createEventPending"
        >
          Skapa händelse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import EventTitleField from './EventForm/EventTitleField'
import EventTimeStartField from './EventForm/EventTimeStartField'
import EventRoutesField from './EventForm/EventRoutesField'
import EventReasonField from './EventForm/EventReasonField'
import EventOperationLevelField from './EventForm/EventOperationLevelField'
import EventBasunFields from './EventForm/EventBasunFields'
import EventLocationField from './EventForm/EventLocationField'
import paramsDistrict from '@/common/paramsDistrict'

export default {
  name: 'EventCreateModal',

  components: {
    EventTitleField,
    EventTimeStartField,
    EventRoutesField,
    EventReasonField,
    EventOperationLevelField,
    EventBasunFields,
    EventLocationField
  },

  data: () => ({
    valid: true,
    createEventPending: false
  }),

  computed: {
    model: sync('event/model')
  },

  created() {
    this.model.time_start = new Date()
  },

  methods: {
    async onCreateEvent() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.createEventPending = true

      const payload = Object.keys(this.model)
        .filter(e => this.model[e] !== null)
        .reduce((o, e) => {
          if (e === 'basun_time' && !this.model.basun) {
            return o
          }
          o[e] = this.model[e]
          return o
        }, {})

      payload.district_id = this.$store.get('app/selectedDistrictId')

      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateEventInput!) {
            createEvent(payload: $payload) {
              event {
                uuid
                title
                time_start
                district_id
                comment
                basun
                location
                basun_time
                last_sms_message {
                  uuid
                  event_uuid
                  trips {
                    trip_uuid
                    data {
                      sms_text
                      reason_code
                      bookings {
                        first_name
                        last_name
                        phone_number
                        train_number
                        departure_date
                        time_start
                        time_end
                        place_start
                        place_end
                      }
                    }
                  }
                }
                sms_messages {
                  uuid
                  event_uuid
                  trips {
                    trip_uuid
                    data {
                      bookings {
                        first_name
                        last_name
                        phone_number
                        train_number
                        departure_date
                        time_start
                        time_end
                        place_start
                        place_end
                      }
                    }
                  }
                }
                last_dua_message {
                  created
                  body {
                    response_data
                    trip_uuid
                    data
                  }
                }
                last_traffic_message {
                  created
                  event_uuid
                  subject
                  routes
                  delays
                  replacements
                  yellow_vests
                  train_deviations
                  turnarounds
                  forecast_comment
                  replacement_comment
                  yellow_vest_comment
                  consequence
                }
                routes {
                  uuid
                  from_place
                  to_place
                }
                reason {
                  name
                  uuid
                }
                operation_level {
                  uuid
                  name
                }
              }
            }
          }
        `,
        variables: {
          payload
        }
      })
      this.createEventPending = false
      this.$store.commit('event/create', data.createEvent.event)
      this.$store.dispatch('event/selectEvent', this.model.uuid)
      this.$router.push(
        `/${paramsDistrict(this.$store.state.app.selectedDistrictId)}/event/${
          this.model.uuid
        }`
      )
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('event/resetModel')

      this.$emit('close')
    }
  }
}
</script>
